export default {
  properties: {
    display_name: {
      type: 'string',
      description: 'display name of the Mall ; eg : Westfield Les 4 Temps'
    },
    description: { type: 'string', description: 'Retailer description' },
    logo: {
      type: 'string',
      description: 'Retailer Logo',
      format: 'binary',
      binaryEncoding: 'base64'
    },
    website_uri: { type: 'string', description: 'Retailer website' },
    phone_number: { type: 'string', description: 'Retailer phone' },
    opening_hours: { type: 'string', description: 'Opening hours' },
    location_address: { type: 'string', description: 'location address' }
  },
  additionalProperties: false,
  type: 'object',
  title: 'Mall',
  description: 'Malls',
  required: []
};
